/* src/app/modules_v2/booking/locations/components/sections/location-general-section/location-general-section.component.css */
.section-container {
}
.w-100 {
  width: 100%;
}
.merchant-location-form {
  padding: 20px;
}
.merchant-location-form h6.fw-bold {
  color: #333;
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}
.merchant-location-form .row.mb-3 {
  margin-bottom: 20px;
}
.merchant-location-form mat-form-field {
  width: 100%;
}
.merchant-location-form mat-checkbox {
  margin-top: 8px;
}
/*# sourceMappingURL=location-general-section.component.css.map */
